// Currency display helpers — shared across pages.
const SYMBOLS = { INR: "\u20b9", USD: "$" };

export const SUPPORTED_CURRENCIES = ["INR", "USD"];

export const currencySymbol = (code) => SYMBOLS[(code || "INR").toUpperCase()] || "\u20b9";

export const formatCurrency = (amount, code) => {
  if (amount == null) return "—";
  const sym = currencySymbol(code);
  const locale = (code || "INR").toUpperCase() === "INR" ? "en-IN" : "en-US";
  return `${sym}${new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(amount)}`;
};
